import Alert from '@mui/material/Alert';
import Typography from "@mui/material/Typography";
import { when } from "util/support";
import { withDetectIncomplete } from "features/ecommerce/helpers";
import { OnboardingPaymentMethod } from "ui/molecules/PaymentMethod";
import { Collection } from "ui/support/Resource";
import When from 'ui/support/When';
import OnboardingForm from "ui/forms/ECommerce/Onboarding/OnboardingForm";
import {
    FormField,
    type PaymentMethod as PaymentMethodType,
    type OnboardingPaymentMethodsProps
} from "./types";

export const PaymentMethods = ({
    values,
    isSubmitting,
    isValid,
    isBootstrapDataLoading,
    isIncomplete,
    requestedChangeFields,
    bootstrapData,
    setFieldValue,
    setFieldTouched,
    handleChange,
    handleBlur,
    handleSubmit,
    ...form
}: OnboardingPaymentMethodsProps) => (
    <OnboardingForm
        {...form}
        isSubmitting={isSubmitting}
        isValid={isValid}
        isIncomplete={isIncomplete}
        requestedChangeFields={requestedChangeFields}
        handleSubmit={handleSubmit}
    >
        <Typography
            variant='h6'
            color='error'
        >
            Marius, add HR support.
            This is dummy form to occupy the space.
        </Typography>
        {(typeof requestedChangeFields !== 'string') && (
            <When
                if={Boolean(requestedChangeFields)}
                then={() => (
                    <Alert
                        severity='warning'
                    >
                        <>
                            {requestedChangeFields!.comments}
                        </>
                    </Alert>
                )}
            />
        )}
        <Collection
            collection={bootstrapData.methods}
            renderResource={(paymentMethod: PaymentMethodType, index) => {
                const tags = values[FormField.Methods];
                const isChecked = tags.includes(paymentMethod.tag);

                return (
                    <OnboardingPaymentMethod
                        {...paymentMethod}
                        key={index}
                        disabled={!withDetectIncomplete(isIncomplete, requestedChangeFields)}
                        checked={isChecked}
                        onChange={() => {
                            when(
                                isChecked,
                                () => setFieldValue(
                                    FormField.Methods,
                                    tags.filter(tag => !Object.is(paymentMethod.tag, tag))
                                ),
                                () => setFieldValue(
                                    FormField.Methods,
                                    [...tags, paymentMethod.tag]
                                )
                            );

                            setTimeout(() => setFieldTouched(FormField.Methods, true, true));
                        }}
                    />
                );
            }}
        />
    </OnboardingForm>
);

export default PaymentMethods;
